"use client";

import React, {ReactNode, useEffect, useState} from "react";
import Link from "next/link";
import {Placeholder} from "@/components/placeholder";
import { contactInfo } from "@/lib/api/contacts";



type DataType = {
    question: string
    answer: ReactNode
}

type FaqListType = {
    title: string
    data: DataType[]
    down?:boolean
}

const Title = ({title}:{title:string}) => {
    return <h3 className="text-center font-black text-2xl mb-8 max-md:mb-12"
               style={{fontFamily: "Hotel Collection"}}>
        {title}
    </h3>
}

const FaqList = (props: FaqListType) => {
    const [showList, setShowList] = useState(props.data.map(item => ({...item, show: false})));
    const changeShowStatus = (dataIndex: number) => {
        const newList = showList.map((item, index) => {
            if (dataIndex === index) {
                return { ...item, show: !item.show };
            } else {
                return item;
            }
        });
        setShowList(newList);
    };
    return <div>
        <Title title={props.title}></Title>
        <div>
            {showList.map((item, index) => {
                return <div key={index} className="border-b last:border-0 overflow-hidden">
                    <div className={`b-flex px-2 cursor-pointer duration-300 group ${item.show ? "bg-[#f0efef]" : "bg-white"}`}
                         onClick={() => changeShowStatus(index)}>
                        <p
                            className="h-16 text-base leading-[20px] font-black c-flex">{item.question.toUpperCase()}</p>
                        <i
                            className={`ri-arrow-down-s-line w-[24px] h-[24px] text-center leading-[24px] rounded-full group-hover:bg-main group-hover:text-white duration-300
              ${item.show ? "bg-main text-white rotate-180" : "bg-[#f0efef] text-black rotate-0"}
              `}
                        ></i>
                    </div>
                    <div
                         className={`faqAnswersCont px-2 duration-500 max-md:text-[12px] ${item.show ? "max-h-[300px] overflow-y-auto py-2" : "max-h-0 overflow-y-hidden "}`}
                    >
                        {
                            item.answer
                        }
                    </div>
                </div>;
            })}
        </div>
    </div>;
};

interface ContentType {
    title:string
    list:ReactNode
}
const ContentComponent = ({data}:{data:ContentType[]}) => {
    return <ul>
        {
            data.map((item,index)=>(
                <li key={index}>
                    <h4 className={'text-md font-bold'}>
                        {
                            item.title
                        }
                    </h4>
                    <div className={'space-y-4 py-4'}>
                        {
                            item.list
                        }
                    </div>
                </li>
            ))
        }
    </ul>
}

const MainSpan = ({text,link}:{text:string,link?:string}) => {
    return <>
        {
            link ? <Link href={link} className={'text-main'}>{text}</Link> : <span className={'text-main'}>{text}</span>
        }
    </>
}

const RegisterComponent = () => {
    const data = [
        {
            title:'1. 进入注册页面',
            list:<>
                <p>恒配达首页点击顶部导航栏或右侧功能栏<MainSpan text={'【注册】'}></MainSpan>按钮</p>
            </>
        },
        {
            title:'2. 同意用户协议',
            list:<>
                <p>认真阅读用户注册协议弹窗内容，并点击<MainSpan text={'【我已阅读并同意】'}></MainSpan></p>
            </>
        },
        {
            title:'3. 填写注册信息',
            list: <>
                <p>01: 填写注册类型</p>
                <p>02: 填写公司名称</p>
                <p>03: 填写姓名</p>
                <p>04: 设置密码</p>
                <p>05: 填写手机号+获取验证码</p>
                <p>06: 点击<MainSpan text={'【立即注册】'}></MainSpan>击即可注册成功</p>
                <p>备注：注册信息填写页面，带“<MainSpan text={'*'}></MainSpan>”符号为必填项</p>
            </>
        },
        {
            title:'4. 完善信息',
            list:<>
                <p>注册完成后可点击<MainSpan text={'【开启采购之旅】'}></MainSpan>，或点击<MainSpan text={'【去完善信息】'}></MainSpan></p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const HowToSelect = () => {
    const data = [
        {
            title:'一、关键词搜索查找',
            list:<>
                <p>点击商城首页，在搜索栏输入产品关键词，如输入“直线轴承”搜索，下拉框可检索出关于“直线轴承”的产品。</p>
            </>
        },
        {
            title:'二、产品分类或者产品图标查找',
            list:<>
                <p>在首页左侧可查看商品总类，鼠标经过商品总类时可弹窗出右侧的小分类及下面的小图标。</p>
            </>
        },
        {
            title:'三、非标定制选型',
            list: <>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const AboutUs = () => {
    const data = [
        {
            title:'1. 走进恒配达',
            list: <>
                <p>鼎尖商城依托东莞市鼎尖精密传动机械有限公司，专注于传动零部件的生产、研发与销售服务。公司位于广东省东莞市厚街镇，已取得 ISO9001 质量管理体系认证，可为客户提供稳定、可靠的传动零部件产品与配套采购服务。</p>
                <p>东莞市恒配达自动化配件有限公司，成立于2014年7月，位于东莞制造业基地厚街白濠，公司占地使用面积15000平方米，恒配达致力于自动化零部件研发、生产、销售、服务于一体，多年深耕自动化行业，为自动化设备提供自动化零部件一站式采购服务。</p>
                <p>产品涵盖机械常用零部件、直线运动零部件、传动零部件、紧固零件、及气动配件产品等，恒配达零部件商城目标提升自动化设备供给效率，降低采购商的综合采购成本，节省采购商的采购时间，为机械设备行业带来改变。</p>
                <p>成立时间2014   行业经验10年  自营工厂设备360台  15000平方米生产厂房  千万现货常规库存</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const ContactUs = () => {
    const data = [
        {
            title:'',
            list: <>
                <p className={'mb-6'}>您可以通过电话、E-mail、信函等方式向我们咨询产品报价、技术支持、售前售后等服务，恒配达主要以电话和短信的方式进行客户关怀、各种服务提醒及产品使用常识指导；并通过恒配达的强大的后台支撑体系，为客户处理解决问题。同时，主动向客户了解产品、服务的需求、建议，不断的改进产品、服务，为客户提供全心管家式服务。</p>
                <p>东莞市恒配达自动化配件有限公司</p>
                <p>服务热线：{contactInfo.Tel}</p>
                <p>技术支持：{contactInfo.phone}</p>
                <p>投诉电话：{contactInfo.phone}</p>
                <p>邮箱：{contactInfo.email}</p>
                <p>地址：{contactInfo.address}</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const ShoppingGuide = () => {
    const data = [
        {
            title:'一、登录恒配达网址：',
            list: <>
                <p>1. 在首页搜索框输入产品名称或产品型号。</p>
                <p>2. 首页左侧的商品总类鼠标经过弹出右侧的窗口，点击小分类可进入产品页面。</p>
                <p>3. 选好参数型号后，显示无价格的商品可点击<MainSpan text={'【快速询价】'}></MainSpan>。</p>
                <p className={'mt-6'}>4.可选择批量导入产品参数（批量导入模板下载）支持可上传相关产品文件，如图型等等，附件支持png、jpg、jpeg、svg、bmp、pdf、stl、obj、IGS、IGES、step、stp、X_T、X_B、dwg、obs、3ds、max、sldasm、sldprt、glb等格式，
                    单文件30M以内。</p>
                <p>5.点击<MainSpan text={'【下一步】'}></MainSpan>，跳转点击<MainSpan text={'【生成报价】'}></MainSpan>。</p>
                <p>6.点击<MainSpan text={'【返回报价单】'}></MainSpan>，等待平台客服报价。</p>
                <p>7. 点击<MainSpan text={'【报价单详情】'}></MainSpan>查看订单，点击<MainSpan text={'【去下单】'}></MainSpan>付款。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const BulkBuying = () => {
    const data = [
        {
            title:'1. 批量加入购物车购买：',
            list: <>
                <p>登录恒配达账号，点击进入产品页面，型号选好加入购物车，可多种产品依次加入购物车，最后一步完成结算并付款。</p>
            </>
        },
        {
            title:'2. 询价单批量购买：',
            list: <>
                <p>1.首页点击<MainSpan text={'【快速报价】'}></MainSpan>或<MainSpan text={'【发布询价】'}></MainSpan>。</p>
                <p>2.填写报价表或者<MainSpan text={'【下载批量模板】'}></MainSpan>批量导入，点击<MainSpan text={'【下一步】'}></MainSpan>。</p>
                <p>3.点击生成报价单。</p>
                <p>4.待平台客服报价完成，可在<MainSpan text={'【个人中心】'}></MainSpan>—<MainSpan text={'【我的询价单】'}></MainSpan>—<MainSpan text={'【报价单详情】'}></MainSpan>。</p>
                <p>5.核对购物信息、收货地址，最后提交订单并付款</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const OrderingRelatedIssues = () => {
    const ContainerDiv = ({children}:{children:ReactNode}) => {
        return <div className={'space-y-1'}>
            {children}
        </div>
    }
    const data = [
        {
            title:'',
            list: <>
                <ContainerDiv>
                    <p>问：如何批量报价？</p>
                    <p>答：在官网首页右上角点击【快速报价】进入填写报价页面，填写产品名称、产品型号、品牌、数量等；
                        表格批量上传：下载我们的批量导入模版，从您的EXCEL复制单元格黏贴到模版表格后保存，点击【批量导入】即可导入。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何查询商品库存？</p>
                    <p>答：你可以在商品详情页通过调整数量查看参考库存，您也可以将商品加入购物车后调整数量查看。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何查看商品售卖单位、包装数？</p>
                    <p>答：商品详情页会有相关提示，如无特殊标记，默认按个销售，产品加入购物车也会显示相关信息。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何查看品牌？</p>
                    <p>答：商品详情页会有品牌标识，产品加入购物车也能查看品牌。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：库存不足如何操作？</p>
                    <p>答：您可以在产品选型详情页面点击【快速报价】进入填写报价单页面确认添加数量，点击“下一步”，点击“生成报价单”，
                        在“我的报价单”；或直接咨询在线客服库存数量。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：商品超出最大订购数量怎么办？</p>
                    <p>答：在商品详情页中选择【快速报价】，确认数量生成报价单。如有需我司报价的商品，预计在营业时间的2-4小时后回复，
                        请在“我的询价单”中查看最新状态。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何订购商品？</p>
                    <p>答：在官网首页搜索框输入商品名称、或者商品型号检索进入商品页面，选好型号后直接【一键购买】；快速报价的商品，
                        填好报价单后【生成报价单】，需我司确认报价后再将报价单转成订单购买。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：商品可以分开发货吗？</p>
                    <p>答：您可以分开下单，提交订单时备注分开发货即可。我司提供以下三种发货方式供您选择(不额外产生费用)；
                        一起发货：所有商品按订单中的最晚发货日出货；
                        分开发货：按各种商品的最早发货日出货；
                        指定时间发货：按您指定的日期出货。(指定的日期必须晚于最早发货日)</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何查看报价单有效期？</p>
                    <p>答：正常报价单的有效期为1天，如您的商品有提交恒配达确认，请在报价详情页直接查看商品有效期。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何查看订单有效期？</p>
                    <p>答：如订单无特殊确认的商品，网站标准有效期为24小时，过期后订单将自动取消，请在有效期内尽快完成付款。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何查看订单付款时效？</p>
                    <p>答：官网提交订单后，您可在订单详情页面，查看付款时效，超过付款时效系统将自动关闭该订单。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：安昂的付款方式有哪些？</p>
                    <p>答：预付款客户支付方式如下：
                        (1)在线支付：支持微信、支付宝、银联(公对公网银转账)。
                        (2)银行转账：请根据安昂报价单上的付款信息进行公对公转账。
                    </p>
                    <p><MainSpan
                        text={'注：网站订购付款方式默认为“在线支付”，若您不方便使用在线支付，无须再重新提交订单，直接线下银行转账付款即可。'}></MainSpan></p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：可以支持二维码付款吗？</p>
                    <p>答：预付款客户支持微信和支付宝二维码扫码支付，您可以在订单确认页面左下方选择在线支付订单。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：如何维护发票信息？</p>
                    <p>答：可在右上角的【会员中心】-【个人中心】点击【发票管理】进行维护。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：我什么时候可以报价或者订购？</p>
                    <p>答：24小时随时报价/订购。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：我怎样才能更方便的再次订购以前订过的商品？</p>
                    <p>答：您不需要重新输入订单内容，您可以在订购记录中查找您要重新订购的订单，勾选您需要订购的商品，
                        然后点击【再次报价】，待我司报价请确认价格和发货日期无误后在订购。</p>
                </ContainerDiv>
                <ContainerDiv>
                    <p>问：什么是数量折扣？</p>
                    <p>答：同一型号商品购入数量越多，根据商品数量会有相应的折扣；根据商品不用满足折扣的数量不同及折扣率不同，详情请查看商品页。</p>
                </ContainerDiv>
            </>
        },
        {
            title: '2. 询价单批量购买：',
            list: <>
                <p>1.首页点击<MainSpan text={'【快速报价】'}></MainSpan>或<MainSpan text={'【发布询价】'}></MainSpan>。</p>
                <p>2.填写报价表或者<MainSpan text={'【下载批量模板】'}></MainSpan>批量导入，点击<MainSpan text={'【下一步】'}></MainSpan>。</p>
                <p>3.点击生成报价单。</p>
                <p>4.待平台客服报价完成，可在<MainSpan text={'【个人中心】'}></MainSpan>—<MainSpan text={'【我的询价单】'}></MainSpan>—<MainSpan text={'【报价单详情】'}></MainSpan>。</p>
                <p>5.核对购物信息、收货地址，最后提交订单并付款</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const HowChangeUserCenter = () => {

    const data = [
        {
            title:'',
            list: <>
                <p>1.登录账号，点击头像下方的<MainSpan text={'【个人中心】'}></MainSpan>。</p>
                <p>2.进入会员中心，点击<MainSpan text={'【账户信息】'}></MainSpan>。</p>
                <p>3.进入个人信息页面后，即可修改个人信息，修改信息完成后下拉页面，点击<MainSpan text={'【保存修改】'}></MainSpan>按钮，完成信息修改。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const HowManageAddress = () => {

    const data = [
        {
            title:'一、添加新收货地址',
            list: <>
                <p>1.登录恒配达账号，点击首页头像下方的<MainSpan text={'【个人中心】'}></MainSpan>。</p>
                <p>2.点击<MainSpan text={'【收货地址】'}></MainSpan>-<MainSpan text={'【新增】'}></MainSpan>地址，带‘*’号的收货人、手机、地址、详细地址必填项，填好后点击下方的确认修改即可。</p>
            </>
        },
        {
            title:'二、编辑/删除收货地址',
            list: <>
                <p>1.登录安昂账号，点击首页头像下方的<MainSpan text={'【个人中心】'}></MainSpan>。</p>
                <p>2.点击<MainSpan text={'【收货地址】'}></MainSpan>，根据您的选择来<MainSpan text={'【编辑】'}></MainSpan>或者<MainSpan text={'【删除】'}></MainSpan>收货信息。</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const ForgetPassword = () => {
    const data = [
        {
            title:'一、通过手机验证码找回密码',
            list: <>
                <p>1.在官网首页的头像下方点击<MainSpan text={'【登录】'}></MainSpan>。</p>
                <p>2.点击<MainSpan text={'【账号登陆】'}></MainSpan>-<MainSpan text={'【忘记密码】'}></MainSpan>。</p>
                <p>3.输入手机号、验证码和接收短信验证码，点击<MainSpan text={'【重设密码】'}></MainSpan>。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const MembershipRights = () => {
    const data = [
        {
            title:'1.会员类型：未注册会员和注册会员，会员权限描述如下：',
            list: <>
                <Placeholder src={'/help-center/img.png'} imageWidth={1200} imageHeight={1000}></Placeholder>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const PayWay = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>平台的付款方式有以下几种，您可根据实际情况完成付款：</p>
                <p>1.平台支付：支付宝、微信通过手机扫描付款二维码即可完成在线支付；</p>
                <p>2.线下支付：线下通过银行转账到恒配达公司账户；</p>
            </>
        },
        {
            title:'1、平台支付',
            list: <>
                <p>您的支付方式为在线支付，请选择 支付宝 或 微信，并通过手机扫码完成订购。</p>
                <p>(1)选择支付宝或微信支付时，点击<MainSpan text={'【确认支付】'}></MainSpan></p>
                <p>(2)用对应APP扫码付款，支付成功后可根据需求查看订单详情</p>
            </>
        },
        {
            title:'2、线下支付（对公转账）',
            list: <>
                <p>线下通过银行转账到恒配达对公账号</p>
                <p>(1)选择平台订单支付中的“银行转账”，按照界面展示的银行收款账号进行汇款，并点击<MainSpan
                    text={'【上传凭证】'}></MainSpan>按钮，完成订单支付。</p>
                <p>(2)待我司在确认已收到款项后，将及时处理订单。 如有疑惑可联系：0769-81506106 或者联系您的专属客服！</p>
                <p>汇款资料</p>
                <p>名称：东莞市恒配达自动化配件有限公司</p>
                <p>开户行：XXXXX</p>
                <p>账号：XXXXXXXXX</p>
                <p>行号：XXXXXXXXX</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const CancelPurchase = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>1.登录账号后，想要取消订单，可在<MainSpan text={'【个人中心】'}></MainSpan>进入；</p>
                <p>2.点击左侧下方<MainSpan text={'【我的订单】'}></MainSpan>，找到最新的订单确认<MainSpan text={'【取消订单】'}></MainSpan>。</p>
                <p>3.当您已下单并付款成功，需要取消订单的请及时联系客服人员沟通确认工厂物料是否出库，如订单还在备料中即可取消订单，货款将原路返还。</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}


const SalesReturn = () => {
    const data = [
        {
            title:'1. 在电脑上申请操作步骤：',
            list: <>
                <p>登陆鼎坚传动（WWW.XXXX.COM），进入“我的订单”（首页最上方），点击“<MainSpan text={'在线客户服务'}></MainSpan>”，说明理由，鼎坚售后会结合情况处理“<MainSpan text={'返修/退换货'}></MainSpan>”售后问题，提交成功后请耐心等待，由专业的售后工作人员受理您的申请。</p>
            </>
        },
        {
            title:'2. 在手机上如何申请：',
            list: <>
                <p>打开鼎坚传动移动端，点击在线客服&gt;退换/售后&gt;申请售后，由专业的售后工作人员受理您的申请。</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const RefundInstructions = () => {
    const data = [
        {
            title:'',
            list: <>
                <p className={'text-main'}>取消订单后如何退款：</p>
                <p>在线支付的订单（包含使用优惠券、账户余额、等货到付款的订单）取消成功后，我们会为您提供“订单快速退款”服务，鼎坚退款处理时效如下：</p>
            </>
        },
        {
            title:'1、鼎坚自营商品订单：',
            list: <>
                <p>由于鼎坚传动产品大部分为进口、非标订制品，客户经确认合同下单后，均不允许退换货。除非出现品质问题等其他由鼎坚商城造成的问题。</p>
            </>
        },
        {
            title:'2、与客服商议同意退款后：',
            list: <>
                <p>商品出库前：若您在商品未出库前提交取消申请，会在30分钟后完成退款审核。</p>
                <p>商品送往配送站前：若您在商品已经出库，等待装车送往配送站前提交取消申请，会在商品退库之后系统会为您退款。</p>
                <p>商品送往配送站的途中：若您在订单商品已经装车送往配送站的途中提交取消申请，会在商品退库之后系统会为您退款。</p>
                <p>拒收订单：订单拒收后，系统会自动帮您提交取消申请，商品退库之后系统会为您退款。若超过时效未完成退款审核，请联系鼎坚客服咨询。</p>
            </>
        },
        {
            title:'3、退货后如何退款：',
            list: <>
                <p>注：鼎坚在线支付及POS机刷卡支付订单退款，如涉及到银行信息鼎坚会依据银行及相关机构已经建立的条例处理退款，为了保证客户账户金额的安全，我们均会安排原卡原退。</p>
                <p><span className={'font-bold'}>温馨提示：</span>具体退款周期可能会受银行、支付机构等相关因素影响。</p>
                <p>1. 公司转账或支票支付的订单，需与客服人员确认公司相关信息后进行公司转账,目前鼎坚只支持原路退回至客户原支付的公司账户中，给您带来的不便请您谅解。</p>
                <p>2. 鼎坚优惠券支付退款无法直接兑换成现金，会在1个工作日左右返还至您支付的鼎坚个人账户内。</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const HowLongDelivered = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>1.下单后我们正常是24-48小时内完成发货，特殊情况除外，定制商品请联系在线客服确认发货时间。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const QueryLogistics = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>登陆鼎坚传动（WWW.XXXX.COM），进入“我的订单”（首页最上方），找到你要需要查询的订单然后点击“查询物流”，</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const ShippingInstructions = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>1、买家通过在线交易并在线上完成付款或货到付款下单成功后，我司将在规定的货期内发货。</p>
                <p>2、物流标的分为“市内、省内、全国”，市内为东莞市内，省内为广东省内，全国即为面向全国其他地区。快递都是按公斤收取邮费，不足一公斤按一公斤算。货品重量超出30公斤，建议选择物流。</p>
                <p>3、江、浙、沪、闽、粤地区发货后1-3个工作日到，其他地区发货后3-5个工作日到，新疆、西藏等边远地区可能要5-7个工作日左右。</p>
                <p>4、港、澳、台及海外暂不支持配送；如新疆、宁夏、西藏、青海、内蒙古等偏远地区运费由买家承担，请您谅解。</p>
                <p>5、在条件允许的情况下，我司会满足买家的对物流的变更需求，但是当买家的订单已经进入处理阶段或已发货，买家则不能够再变更收货地址。</p>
                <p>6、因买家填写的收货地址和(或)收货人信息不准确，导致我司发货后货品无法送达的，运费由买家承担。</p>
                <p>7、我司目前默认承运公司为顺丰快递、德邦快递。买家有指定承运人的，在和客服沟通之后，我司也可以根据买家的需求再选择配送方式。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const Download3DModel = () => {
    const data = [
        {
            title:'01、下载入口',
            list: <>
                <p>1、登录鼎坚传动—【3D模型库】：https://www.XXX.COM/3d.html</p>
                <p>2、商品选型详情页自动匹配</p>
            </>
        },
        {
            title:'02、登录账号',
            list: <>
                <p>选择需要的产品，例：联轴器</p>
            </>
        },
        {
            title:'03、选择参数',
            list: <>
                <p>选择参数、生成具体型号</p>
            </>
        },
        {
            title:'04、预览模型',
            list: <>
                <p>点击“3D模型预览”</p>
            </>
        },
        {
            title:'05、去下载',
            list: <>
                <p>预览图生成后，点击预览图的“中上角1、右上角2按钮”去进入下载界面</p>
            </>
        },
        {
            title:'06、选择格式',
            list: <>
                <p>点击“生成CAD模型”按钮，添加需要生成的图纸格式</p>
            </>
        },
        {
            title:'07、生成并下载预览模型',
            list: <>
                <p>图纸格式添加后，点击“点击此处生成CAD模型”按钮，生成图纸
                    图纸加载后，点击“下载”按钮，即可开始下载</p>
            </>
        },
        {
            title:'08、解压并使用',
            list: <>
                <p>图纸下载本地后，解压方可使用</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const DownloadElectronicMaterials = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>电子档资料下载有两个方法：①在相关产品详情页下载相应的电子档资料；</p>
                <p>②首页导航栏点击“资料下载”进入资料页面，在上方搜索框输入商品名称查询。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

const MallService = () => {
    const data = [
        {
            title:'',
            list: <>
                <p>您注册成为鼎坚传动零部件商城用户前，必须仔细阅读本服务条款和隐私政策，一旦您注册成为了鼎坚传动零部件商城零部件商城用户即表示您已经阅读、同意并接受本用户服务条款和隐私政策中所含的所有条款和条件。</p>
                <p>除另有特别标注外，东莞市鼎坚精密传动机式有限公司（以下简称“本公司”）为本公司运营的网站（包括但不限于URL：https://www.XXX.com,。以下统称“本网站”）上所有页面设计、页面内容的著作权人或授权使用人。本公司对本网站所载的内容，包括但不限于网站所载的产品目录、文字、数据、图形、照片、有声文件、动画文件、音视频资料等拥有完整的版权，受著作权法保护。</p>
                <p>使用者或访问者仅限于向本公司询价和订货的目的使用本网站，未经本公司事先书面许可，任何单位和个人均不得以任何方式将本网站及其内容用于上述以外的目的。</p>
            </>
        },
        {
            title:'第一条 注册会员',
            list: <>
                <p>1．用户资格：本网站用户必须是适用法律下能够签订具有法律约束力的合同的个人或组织机构。如您不合资格，请不要使用我们的服务。</p>
                <p>2．注册会员：使用本服务的个人或组织机构应先行完成会员注册手续。请按照本网站指定的方法办理会员注册手续，本公司根据规定批准其入会后可取得会员编号及用户ID，成为正式会员（以下简称“客户”）。</p>
                <p>3．转让或出售：您在本网站的帐户不得向其他方转让或出售。本网站保留根据其意愿中止或终止您的帐户的权利。</p>
                <p>4．资料填写：为确保交易的正常进行，用户必须向本网站提供真实、有效的个人资料，如个人资料有任何变动，必须及时通知本网站更新。</p>
                <p>5．信息传达：本公司会发送本公司的各种产品目录、DM等，或用传真以及E-mail将各项促销活动通知客户。本网站用户同意接收来自鼎坚传动零部件商城或者鼎坚传动合作伙伴发出的邮件、信息。客户有权要求停止发送此类通知。</p>
                <p>6．取消会员：如客户违反本网站服务条款，本公司可以取消该客户的会员资格，可以在不预先通知的情况下暂停或停止向其提供本网站服务全部或部分，以及可以在不预先告知的情况下直接解除已经成立的买卖合同。</p>
            </>
        },
        {
            title:'第二条 ID及密码的管理',
            list: <>
                <p>1．客户对所取得的客户编号及用户ID和密码承担管理责任。</p>
                <p>2．客户不得向第三方转让、出借或者透露客户编号及用户ID和密码。</p>
                <p>使用者或访问者仅限于向本公司询价和订货的目的使用本网站，未经本公司事先书面许可，任何单位和个人均不得以任何方式将本网站及其内容用于上述以外的目的。</p>
            </>
        },
        {
            title:'第三条 商城服务内容',
            list: <>
                <p>1．客户在遵守本使用规则的前提下，可以通过本网站了解产品信息、订购产品并获得服务信息。但是，由于商品的性质、客户的业务内容及其他本公司制订的标准、或者外加工方或者本公司的情况等发生变化，部分商品会在没有事先通知、预告的情况下无法从本网站订购，请予以谅解。</p>
                <p>2．本服务的具体事项以及本商品的价格、交付期限等，可能会根据市场情况、各个客户编号的交易情况和交易条件的不同而不同。</p>
                <p>3．客户以其它公司型号选型，在本公司网站上可以尝试提供替换选型服务，但本公司不保证能全部满足客户需求；</p>
                <p>4．对于要求以超出本网站刊载的数量或折扣条件大批订货的，商品的价格和交货期应另行协商。</p>
            </>
        },
        {
            title: '第四条 商品或服务订购',
            list: <>
                <p>1．客户注册成为会员后，在本网站上根据提示填入必要事项进行选型、询价和下单采购。</p>
                <p>2．本公司在收到客户按照规定填写信息并确认发出的电子订单后订单即生效，但因通讯线路等问题导致客户发出的数据未能被接收的，或者订购的必要事项不完整的，将视为无效订购。本公司对客户因交易失败而产生的相关损失不承担任何责任。</p>
                <p>3．客户订单生效后客户需要变更或取消订单的，应按商城规则、流程取消或变更，或向本公司客服人员咨询流程。</p>
                <p>4．客户应在遵守本网站刊载的商品的规格、用途、使用上的注意事项、使用条件、图纸及其他与商品相关的事项以及商品(包括附件)的附加文件上记载的其他的规定(包括但不限于此)的前提下订购、使用本商品。</p>
                <p>5．本公司有可能因商品的性质、种类、数量、交货期、 配送系统等原因不能接受客户的取消等要求。</p>
            </>
        },
        {
            title: '第五条 商品增值税',
            list: <>
                <p>使用本网站订购商品的，客户应注意报价不含增值税，客户还需另行承担增值税。</p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
                <p></p>
            </>
        },
        {
            title: '第六条 商品货款支付',
            list: <>
                <p>客户应根据本网站的付款方式全额支付相关款项。支付所产生的转账手续费等全部由客户承担。</p>
            </>
        },
        {
            title: '第七条 商品的配送及交付',
            list: <>
                <p>1．商品配送到客户登记的送达目的地或者订购时指定的送达目的地的，视为完成交付。客户接受商品时，须在送货单上签字。</p>
                <p>2．交货期同商品抵达客户处的到货日期不同。订购商品时，请客户参照本网站或产品目录刊载的不同地区运送所需天数进行订购。因订购内容不完整、错误，使本公司无法按照通常的订购来处理的，因天气、交通堵塞、道路施工等外部环境原因或者因本商品的发货日恰逢法定休假日等以及其他原因，造成无法在预计时间内送到的，本公司不承担任何责任，请予以谅解。</p>
                <p>3．发生客户拒绝接受本商品的交付，以及其他因客户原因不能送达目的地的情况时(包括收货人不在的情况)，视为该产品已经完成交付。此类情况下，本公司有权要求客户支付与该产品价款相当的赔偿金以弥补本公司损失。 但是，本公司考虑本商品的性质、种类、数量、配送系统等情况后，认为可以另行处理的，不受此限。</p>
                <p>4．客户应在收到商品后7天内确认商品的名称、型号、数量等，就是否有错型号、毁损、变形、不良、瑕疵（与本网站或者产品目录刊载的规格进行核对，属于定制品的，同客户的图纸等进行核对）进行检查，发现不合格品的请在该期限内通知本网站或者相关客服人员。本公司在上述期间内未收到不合格通知的，视为本商品检查合格。</p>
            </>
        },
        {
            title: '第八条 商品风险转移',
            list: <>
                <p>本商品的灭失风险自交付时从本公司转移至客户。</p>
            </>
        },
        {
            title: '第九条 商品的退换处理',
            list: <>
                <p>1．客户要求退换的，请事先电话联系客服中心，客服中心将会就是否接受退换、退换的方法等做出回复和说明。自客户在收到本商品至本公司同意办理退换手续、直至被退换的商品被本公司接收之时的期间内，本商品的灭失毁损风险由客户承担。</p>
                <p>2．如因客户原因导致退换商品，退回所发生的邮寄费用由客户承担。</p>
                <p>3．送达的商品因本公司原因破损或者错发的，请在收到商品后7天内与客服中心取得联系。根据客户提供的信息，本公司确认系本公司原因造成的，本公司将接受客户的退换等要求。该情况下，退回的邮寄费用由本公司承担。</p>
            </>
        },
        {
            title: '第十条 不合格品的处理措施',
            list: <>
                <p>1．在检查中发现本商品的全部或者部分不合格的，由本公司品质部对该商品进行复查，确认是由于本公司的原因造成不合格的，会尽快提供产品更换（属于服务的由本公司再次提供服务）或者根据客户的要求退还不合格品部分的价款。</p>
                <p>2．由于本公司的原因寄送了比订购数量多的商品时，请与对应客服人员联系并及时将多送部分退还到本公司，退回的费用由本公司承担。</p>
            </>
        },
        {
            title: '第十一条 不可抗力等的免责',
            list: <>
                <p>由于自然灾害（包括但不限于地震、洪水、火灾）、法律法规的修改废止、行政行为的介入、运输单位的纠纷、劳动争议及其他不可抗力事件发生产品延迟交付或者无法交付的，本公司将在合理的期间内将相关情况等通知客户，但因此造成的客户损失以及费用，本公司不承担任何赔偿责任。</p>
            </>
        },
        {
            title: '第十二条 产品保证',
            list: <>
                <p>1．本公司确认系本公司原因导致商品破损、变形、缺陷等不良（以下统称“不良”）情况发生的，在客户按照本公司要求就不良的详细情况在与客服确认规定时间内书面通知本公司的前提下，本公司将按照另行规定的质保条款对本商品进行修理或者更换。</p>
                <p>2．本商品有相应生产厂家提供质保的，本公司可以以生产厂家的质保替代本质保。</p>
                <p>3．发生以下各项的情况，即使在商品保证期间内也不得享受本质保。</p>
                <div className={'space-y-1 px-2'}>
                    <p>（1）因客户使用处理上的不注意、错误造成的不良；</p>
                    <p>（2）由于自然灾害（包括但不限于地震、洪水、火灾）导致的不良；</p>
                    <p>（3）不遵照本网站或者产品目录上刊载的规格、用途、使用上的注意事项、使用条件、图纸及其他与本商品相关的事项以及本商品（包括附件）的附属文件上刊载的其他标示的使用所导致的不良；</p>
                    <p>（4）客户对商品进行加工、修理、改造、拆卸后导致的不良，或因使用中其它外力破坏导致的不良；</p>
                </div>
                <p>4．本商品的保证期间为：本商品自本公司出货之日起1年内</p>
                <p>5．非本质保适用范围内的修理或者更换是有偿的，应按照本公司规定另行支付费用。</p>
            </>
        },
        {
            title: '第十三条 变更以及通知',
            list: <>
                <p>1．客户会员注册及申请本网站使用手续时申报的姓名、公司名称、地址、法定代表人、电话号码、传真号码、负责人、E-mail地址等有变更的，应当立刻书面通知本公司，办理相关的手续。</p>
                <p>2．客户企业注册名称进行工商变更时，应当立刻书面通知本公司，由我公司负责办理相关的更名手续。</p>
                <p>3．因客户未及时通知企业注册名称进行工商变更而导致发货错误及相关单据、发票错误的，客户应承担相应的经济损失或费用。</p>
            </>
        },
        {
            title: '第十四条 价格、规格等的变更',
            list: <>
                <p>本公司有权变更、修正本商品的价格、规格、型号、交货期、订购单位等相关信息以及停止销售（以下统称“变更项”），变更项由在本网站上对本商品记载内容的变更（包括因停止销售而删除相关商品信息）或其他本公司自行判断的方式进行通知。变更后，客户订购本商品的，视为客户已认可该变更。但是，非主要事项的细微变更将不通知客户，请予以谅解。</p>
            </>
        },
        {
            title: '第十五条 服务的暂停、停止',
            list: <>
                <p>发生以下事由时，本公司可以在未经事先联系、通知、预告的情况下暂停或停止向客户提供本网站服务的全部或者部分。</p>
                <p>1．因自然灾害（包括但不限于地震、洪水、火灾）、停电等或者电力部门的电路故障等引起的订购接收管理系统或机器发生故障或功能受限的；</p>
                <p>2．因自然灾害（包括但不限于地震、洪水、火灾）、法令的制定和修改或废除、劳动争议以及其他不可抗力事件致使本商品的交付变得困难的；</p>
                <p>3．订购接收管理系统或机器进行必要的维护、保养的；</p>
                <p>4．其他与本网站服务运营相关且本公司认为有必要的情形。</p>
            </>
        },
        {
            title: '第十六条 用户禁止',
            list: <>
                <p>客户使用本网站服务时禁止下述各项行为，如发现我公司会采取用户禁止登录直到通过法律途径进行追究刑事或民事责任：</p>
                <p>1．会员注册时有弄虚作假行为；</p>
                <p>2．妨碍本网站服务的运营，或者有其他可能会妨碍本网站服务的行为；</p>
                <p>3．恶意套取本公司的经营信息，包括但不限于客户资料、产品价格、订单内容等；</p>
                <p>4．侵害本公司的著作权及其他知识产权、名誉权等的行为；</p>
                <p>5．非法侵入本网站后台修改信息的行为；</p>
                <p>6．向本网站发送或者植入有害的电脑病毒或程序的行为；</p>
                <p>7．违反公共道德的行为或其他违反法律的行为，或者有导致这种可能的行为；</p>
                <p>8．将通过使用本网站服务而取得的与公司的合作权利私下转让给第三方的行为；</p>
            </>
        },
        {
            title: '第十七条 知识产权',
            list: <>
                <p>未经著作权人等知识产权所有者许可，客户不得将通过本网站服务得到的任何信息用于专利权法、著作权法等知识产权相关的法规规则许可之外的用途。</p>
            </>
        },
        {
            title: '第十八条 客户信息的使用',
            list: <>
                <p>1．公司通过本网站所获得的客户信息及客户个人信息仅用于以下目的。</p>
                <div className={'px-2 space-y-1'}>
                    <p>（1）用于向客户介绍本公司的产品内容、促销活动</p>
                    <p>（2）用于本公司销售各项产品的确认、配送、服务信息、售后服务、意见收集及各种促销活动、市场调查或其它营销活动。</p>
                </div>
            </>
        },
        {
            title: '第十九条 其它声明',
            list: <>
                <p>1．如本公司纸质产品目录同本网站刊载内容或者电子产品目录不同的，以两者中最新刊载的本商品内容为准。</p>
                <p>2．因使用本网络服务所导致的损失等（包括本网站的订购信息未到达本公司而导致的损失），除本公司有故意或者重大过失外，本公司不承担任何责任。</p>
            </>
        },
        {
            title: '第二十条 管辖法院',
            list: <>
                <p>有关本商品以及本网站服务的一切纠纷以本公司的法定住所地的管辖法院为管辖法院。</p>
            </>
        },
        {
            title: '第二十一条 免责事项',
            list: <>
                <p>本公司在本网站及相关APP、小程序上刊登相关内容时已经履行了全面细致的注意义务，但不对相关内容的完整性、正确性、有效性、安全性等承担保证责任。此外，本公司对使用方使用该信息或未能使用该信息，以及因使用本网站导致的任何损害不承担责任。</p>
                <p>本公司保留未经事前通告变更本网站及相关APP、小程序上刊登的信息的权利。本网站存在中断或中止运营的可能性，请予以谅解。此外，无论何种原因，本公司对于因内容的变更、刊登内容的删除或者未能使用本网站而导致的任何损害不承担责任。</p>
            </>
        },
        {
            title: '第二十二条 规则的改订及认可',
            list: <>
                <p>客户注册使用本网站提供的服务，必须先阅读和确认以上使用规则，注册完成即默认客户已阅读并认同以上使用规则，本使用规则应作为该交易合同的一部分予以适用。</p>
                <p>本公司有权对本使用规则进行改订、变更以及修改（以下统称“改订”），进行改订的，将会及时在本网站相关页面（包括但不限于URL：www.XXX.com）刊载改订后的使用规则。改订以后，客户订购本商品的，视为客户认可该改订内容。</p>
                <p>如您对本协议有任何疑问、意见或建议，您可以通过以下联系方式与我们取得联系，我们将在7个工作日内回复您的请求。</p>
                <p>联系电话：0769-81506160联系邮箱：153886007@qq.com</p>
            </>
        },
    ]
    return <ContentComponent data={data}/>
}

const SubscriptionAgreement = () => {
    const data = [
        {
            title:'1. 在电脑上申请操作步骤：',
            list: <>
                <p>登陆鼎坚传动（WWW.XXXX.COM），进入“我的订单”（首页最上方），点击“<span className={'text-main'}>在线客户服务</span>”，说明理由，鼎坚售后会结合情况处理“<span className={'text-main'}>返修/退换货</span>”售后问题，提交成功后请耐心等待，由专业的售后工作人员受理您的申请。</p>
            </>
        },
        {
            title:"2.在手机上如何申请：",
            list:<>
                <p>打开鼎坚传动移动端，点击在线客服&gt;退换/售后&gt;申请售后，由专业的售后工作人员受理您的申请。</p>
            </>
        }
    ]
    return <ContentComponent data={data}/>
}

export default function HelpCenter() {
    const [asideData, setAsideData] = useState<FaqListType[]>(
        [
            {
                title:'新手指南',
                down:true,
                data:[
                    {
                        question:'用户注册',
                        answer:<RegisterComponent/>
                    },
                    {
                        question:'如何查找商品',
                        answer:<HowToSelect/>
                    }
                ]
            },
            {
                title:'关于我们',
                down:true,
                data:[
                    {
                        question:'了解我们',
                        answer:<AboutUs/>
                    },
                    {
                        question:'联系我们',
                        answer:<ContactUs/>
                    }
                ]
            },
            {
                title:'报价订购',
                down:true,
                data:[
                    {
                        question:'采购指南',
                        answer:<ShoppingGuide/>
                    },
                    {
                        question:'如何批量购买商品',
                        answer:<BulkBuying/>
                    },
                    {
                        question:'如何报价/订购',
                        answer:''
                    },
                    {
                        question:'如何查看订单状态',
                        answer:''
                    },
                    {
                        question:'产品数量折扣',
                        answer:''
                    },
                    {
                        question:'发票说明',
                        answer:''
                    },
                    {
                        question:'报价订购相关问题',
                        answer:<OrderingRelatedIssues/>
                    },
                ]
            },
            {
                title:'个人中心',
                down:true,
                data:[
                    {
                        question:'如何修改个人中心',
                        answer:<HowChangeUserCenter/>
                    },
                    {
                        question:'如何管理收货地址',
                        answer:<HowManageAddress/>
                    },
                    {
                        question:'忘记密码',
                        answer:<ForgetPassword/>
                    },
                    {
                        question:'会员权限',
                        answer:<MembershipRights/>
                    }
                ]
            },
            {
                title:'支付方式',
                down:true,
                data:[
                    {
                        question:'支付方式',
                        answer:<PayWay/>
                    }
                ]
            },
            {
                title:'售后服务',
                down:true,
                data:[
                    {
                        question:'如何取消购买',
                        answer:<CancelPurchase/>
                    },
                    {
                        question:'如何申请退/换货',
                        answer:<SalesReturn/>
                    },
                    {
                        question:'退款说明',
                        answer:<RefundInstructions/>
                    },
                ]
            },
            {
                title:'配送方式',
                down:true,
                data:[
                    {
                        question:'下单后多久可以发货',
                        answer:<HowLongDelivered/>
                    },
                    {
                        question:'如何查询物流配送信息',
                        answer:<QueryLogistics/>
                    },
                    {
                        question:'配送说明',
                        answer:<ShippingInstructions/>
                    },
                ]
            },
            {
                title:'热门问题',
                down:true,
                data:[
                    {
                        question:'如何下载3D模型图',
                        answer:<Download3DModel/>
                    },
                    {
                        question:'如何下载电子档资料',
                        answer:<DownloadElectronicMaterials/>
                    }
                ]
            },
            {
                title:'FA商场协议',
                down:true,
                data:[
                    {
                        question:'商场服务条款',
                        answer:<MallService/>
                    },
                    {
                        question:'商场订单交易订购协议',
                        answer:''
                    },
                    {
                        question:'商场退货规则协议',
                        answer:<SubscriptionAgreement/>
                    }
                ]
            },
        ]
    )
    const changeDown = (name:string) => {
        setAsideData(val=>val.map(item=>item.title === name ? {...item,down: !item.down} : item))
    }

    const handleChangePosition = (positionId:string) => {
        if(!positionId) return
        const ele = document.getElementById(positionId)
        if(ele){
            window.scroll({
                behavior: 'smooth',
                top: ele.offsetTop
            });
        }
    }
    return <>
        <div className={'container grid grid-cols-10 '}>
            <div className={'col-span-2  px-4 relative'}>
                <div className={'sticky top-0 max-h-[100vh] overflow-y-auto pb-4'}>
                    <div
                        className={'bg-[#fafafa] h-[40px] flex items-center pl-2 text-blue-400 font-bold text-lg'}>常见问题
                    </div>
                    <div>
                        {
                            asideData.map((item, index) => (
                                <div key={index} className={'mb-2 last:mb-0'}>
                                    <div
                                        className={'h-[40px] pl-2 pr-4 b-flex bg-[#f5f5f5] cursor-pointer font-bold text-[#666]'}
                                        onClick={() => changeDown(item.title)}>
                                        <span>{item.title}</span>
                                        <i className={`ri-arrow-up-s-line text-[#ccc] duration-300 ${item.down ? 'rotate-0' : 'rotate-180'}`}></i>
                                    </div>
                                    <div className={`duration-300 overflow-hidden `}
                                         style={{height: item.down ? `${item.data.length * 40}px` : '0px'}}>
                                        {
                                            item.data.map((item2, index2) => (
                                                <div key={index2}
                                                     id={item2.question}
                                                     className={'bg-[#fafafa] h-[40px] flex items-center pl-6 text-[#999] cursor-pointer hover:bg-main hover:text-white duration-300'}
                                                     onClick={()=>handleChangePosition(item2.question)}>
                                                    {item2.question}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>
            <div className="py-16 col-span-8">

                <div>
                    {
                        asideData.map((item,index)=>(
                        <div key={index}>
                            <FaqList title={item.title} data={item.data}></FaqList>
                        </div>
                        ))
                    }
                </div>

            </div>
        </div>
    </>
}





